import React from "react";
import { Grid, Tooltip, Typography } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import NumberFormat, { NumberFormatValues } from "react-number-format";
import { makeStyles } from "@mui/styles";

interface AmountInputConfigProps {
    name: string,
    label?: string,
    description?: string,
    value: undefined | number,
    onChange: (ConfigTypeKey: string, AssignedValue: any) => void,
    error: undefined | string,
    onError: (key: string, value: string) => void,
}

export default function AmountInputConfig(
    {
        name,
        label,
        description,
        onChange,
        value,
        error,
        onError,
    }: AmountInputConfigProps
) {
    const inputRootStyle = {
        width: '100px', 
        height: '27px', 
        textAlign: 'center' as 'center',
        borderRadius: '24px', 
        border: '1px solid #F1F0F5', 
        padding: '0 8px',
        outline: 'none !important',
    }

    const useStyles = makeStyles({
        inputRoot: {
            ...inputRootStyle,
            '&:hover': {
                borderColor: 'rgb(0, 0, 0, 0.87)',
            },
            '&:focus': {
                borderColor: 'rgb(25, 118, 210)',
            },
        },
        errorInputRoot: {
            ...inputRootStyle,
            borderColor: 'rgb(211, 47, 47)',
        }
    });
    const classes = useStyles();

    const handleTextChange = (values: NumberFormatValues) => {
        if (values.floatValue === undefined) {
            onChange(`${name}`, '');
            onError(`${name}`, 'This field is required.');
        } else if (values.floatValue*100 !== value) {
            onChange(`${name}`, values.floatValue*100);
            onError(`${name}`, '');
        }
    }

    return (
        <Grid container sx={{ alignItems: 'center', pt: 1.5, pb: 1.5 }}>
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                {!!description && <Tooltip title={description} placement="right">
                    <HelpIcon sx={{ fontSize: 16, color: "#C4C4C4", cursor: "pointer", mr: '9px' }} />
                </Tooltip>}

                {!!label && <Typography 
                    sx={{ 
                        fontFamily: 'Work Sans',
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '22px',
                        marginRight: '13px',
                    }}
                >
                    {label}
                </Typography>}

                <NumberFormat
                    onValueChange={handleTextChange}
                    value={value == null ? null : value / 100}
                    thousandSeparator
                    isNumericString
                    fixedDecimalScale
                    decimalScale={2}
                    prefix="$"
                    className={!error ? classes.inputRoot : classes.errorInputRoot}
                    placeholder="$0.00"
                />
            </Grid>
            {error && (
                <React.Fragment>
                    <Grid item xs={12} md={3.5}></Grid>
                    <Grid item xs={12} md={8.5} sx={{ 
                        textAlign: { xs: 'center', md: 'left' }, 
                        marginTop: { xs: 0, lg: 1 }
                    }}>
                        <Typography 
                            sx={{ 
                                fontFamily: 'Work Sans',
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: '22px',
                                color: '#ff0000',
                            }}
                        >
                            {error}
                        </Typography>
                    </Grid>
                </React.Fragment>
            )}
        </Grid>
    )
}
